const tabs = document.querySelectorAll('.b-value-props__tab');
tabs.forEach(tab => {
    tab.addEventListener('click', () => {
        setActive(tab);
    })
});


const showPanels = (tab) => {
    tab.addEventListener('click', () => {
        let tabIndex = tab.getAttribute('data-tab');
        let tabName = tab.getAttribute('data-section-name');
        let panels = document.querySelectorAll('.b-value-props__panel');
        let sectionWrapper = document.querySelector('.b-value-props');
        
        sectionWrapper.setAttribute('data-panel', tabName)

        panels.forEach(panel => {
            const panelIndex = panel.getAttribute('data-panel');
            if(panelIndex === tabIndex) {
                setActive(panel);
            }
        })
    })
}

const setActive = function (el) {
    [...el.parentElement.children].forEach(function (sib) {
        sib.classList.remove('active');
    });
    el.classList.add('active');
};

tabs.forEach(tab => {
    showPanels(tab);
});